/* eslint-disable consistent-return */
import { ref } from "@nuxtjs/composition-api";
import type { UseCheckOrderInterface, UseCheckOrderErrors } from "./useCheckOrder";
import { Logger } from "~/helpers/logger";
import { getApiAxios } from "~/helpers";
import api from "~/config/extensionsApi";
import { useSearchProducts } from "~/composables";

export function useCheckOrder(): UseCheckOrderInterface {
  const loading = ref<boolean>(false);
  const isOrder = ref<boolean>(false);
  const error = ref<UseCheckOrderErrors>({
    orderSearch: null,
  });
  const { fetchProducts } = useSearchProducts();

  const orderSearchDetail = async (data: any): Promise<any> => {
    let results = null;
    try {
      loading.value = true;
      isOrder.value = false;
      const response = await getApiAxios(
        api.erp.order_status,
        {},
        {
          increment_id: data.increment_id,
          phone_number: data.phone_number,
        }
      );

      if (response && (response.code !== 200 || response.result.errors)) {
        error.value.orderSearch = response.result.errors;
        Logger.error("orderSearchDetail/useCheckOrder: ", response.result);
      } else {
        results = response?.result?.items ?? null;
        if (Array.isArray(results) && 0 < results.length) {
          isOrder.value = true;

          const orderItems = results[0]?.items;
          const productSkus = orderItems?.map((item) => item.sku) || [];
          const productsParentSkus = [
            ...new Set([
              ...productSkus,
              ...(productSkus.map((sku) => sku.split("-")[0]) || []),
              ...(productSkus.map((sku) => {
                const parts = sku.split("-");
                return parts.length > 1 ? `${parts[0]}-${parts[1]}` : parts[0];
              }) || []),
            ]),
          ];
          if (productsParentSkus.length > 0) {
            const params = {
              skus: productsParentSkus,
              loadHidden: true,
            };
            const { data } = await fetchProducts(params);
            const productsParent = data || null;

            // Add parent products to order items
            if (productsParent && productsParent.length > 0) {
              results[0].items = orderItems.map((item) => {

                let productParent = productsParent.find((parent) => {
                  return parent?.configurable_children?.find((child) => {
                    return child?.sku == item?.sku;
                  });
                });

                if (!productParent){
                  productParent = productsParent.find((parent) => {
                    return parent?.sku === item?.sku;
                  });
                }

                if (productParent) {
                  return {
                    ...item,
                    productParent,
                  };
                }
                return item;
              });
            }
          }
        }

        error.value.orderSearch = null;
      }
    } catch (error) {
      Logger.error("orderSearchDetail/useCheckOrder: ", error);
      return null;
    } finally {
      loading.value = false;
    }

    return results;
  };

  return {
    isOrder,
    loading,
    error,
    orderSearchDetail,
  };
}

export default useCheckOrder;
